import { IInitialState, RootState } from '../../../reduxService';
import { rockD50ExceptionGabion, rockD50ImperialValueGabion, thicknessExceptionGabion, thicknessImperialValueGabion } from '../../MACRA_1/components/InputForm/Materials/MaterialCategory/Gabion';
import { thicknessException } from '../../MACRA_1/components/InputForm/Materials/MaterialCategory/Reno';
import { EConversionSIToImperial, convertTo } from '../../conversion';
import { MaterialCategory } from '../../enum/Material';
import { EProjectType, UnitOfMeasure } from '../../enum/project';
import { roundNumbers } from '../../utils/utils';
import { ISlopedGabionResults, ISteppedGabionResults, IVerticalDropsResults } from '../api/IApiResponse';
import { IHydraulicDataSlopedWeirForm, IHydraulicDataSteppedWeirForm } from '../components/InputForm/HydraulicData/IHydraulicData';
import { IWeirGeometrySlopedWeirForm, IWeirGeometrySteppedWeirForm, IWeirGeometryVerticalDropForm } from '../components/InputForm/WeirGeometry/IWeirGeometry';
import { IProjectMacra2 } from '../store/project/projectSlice';

export const selectProject = (state: RootState): IInitialState<IProjectMacra2> => {
    let projectInfo = state.projectInfo.data;
    let project = state.macra2.project.data;
    let isImperial = projectInfo?.unitOfMeasure == UnitOfMeasure.Imperial;
    if (isImperial && !!project?.geometry) {
        let isSlopedWeir = projectInfo?.type === (EProjectType.Macra2 | EProjectType.SlopedWeir);
        let isStepped = projectInfo?.type === (EProjectType.Macra2 | EProjectType.SteppedWeir);
        let isVertical = projectInfo?.type === (EProjectType.Macra2 | EProjectType.VerticalDrop);
        let weirGeometry;

        if (isVertical) {
            weirGeometry = project.weirGeometry as IWeirGeometryVerticalDropForm;
            weirGeometry = {
                ...weirGeometry,
                foundation: convertTo(weirGeometry.foundation, EConversionSIToImperial.m_to_ft),
                layer:
                    !!weirGeometry.layer && !!weirGeometry.layer.length && weirGeometry.layer.length > 0
                        ? weirGeometry.layer.map(wg => ({
                              ...wg,
                              layerWidth: convertTo(wg.layerWidth, EConversionSIToImperial.m_to_ft),
                              layerOffset: convertTo(wg.layerOffset, EConversionSIToImperial.m_to_ft),
                              layerHeight: convertTo(wg.layerHeight, EConversionSIToImperial.m_to_ft),
                          }))
                        : [],
            };
        }
        if (isSlopedWeir) {
            weirGeometry = project.weirGeometry as IWeirGeometrySlopedWeirForm;
            weirGeometry = {
                ...weirGeometry,
                crestLength: weirGeometry.crestLength! >= 0 ? convertTo(weirGeometry.crestLength!, EConversionSIToImperial.m_to_ft) : undefined,
                liningThickness: weirGeometry.liningThickness! >= 0 ? convertTo(weirGeometry.liningThickness!, EConversionSIToImperial.m_to_ft) : undefined,
                height: weirGeometry.height! >= 0 ? convertTo(weirGeometry.height!, EConversionSIToImperial.m_to_ft) : undefined,
            };
        }
        if (isStepped) {
            weirGeometry = project.weirGeometry as IWeirGeometrySteppedWeirForm;
            weirGeometry = {
                ...weirGeometry,
                stepHeight: weirGeometry.stepHeight! >= 0 ? convertTo(weirGeometry.stepHeight, EConversionSIToImperial.m_to_ft) : undefined,
                gabionWidth: weirGeometry.gabionWidth! >= 0 ? convertTo(weirGeometry.gabionWidth!, EConversionSIToImperial.m_to_ft) : undefined,
            };
        }
        if (!!project.hydraulicData) {
            project = {
                ...project,
                hydraulicData: {
                    ...project.hydraulicData,
                    dissipation: (<IHydraulicDataSteppedWeirForm>project.hydraulicData).dissipation,
                    discharge: convertTo(project.hydraulicData.discharge, EConversionSIToImperial.m3s_to_ft3s),
                    riverBedGradient: project.hydraulicData.riverBedGradient,
                    roughnessCoefficient: project.hydraulicData.roughnessCoefficient,
                    soilAdmissibleVelocity: convertTo((<IHydraulicDataSlopedWeirForm>project.hydraulicData).soilAdmissibleVelocity, EConversionSIToImperial.ms_to_fts),
                },
            };
        }
        if (!!project.geometry) {
            project = {
                ...project,
                geometry: {
                    ...project.geometry,
                    bankTopElevation: convertTo(project.geometry.bankTopElevation, EConversionSIToImperial.m_to_ft),
                    channelWidth: convertTo(project.geometry.channelWidth, EConversionSIToImperial.m_to_ft),
                },
            };
        }
        project = {
            ...project,

            weirGeometry: {
                ...project.weirGeometry,
                ...weirGeometry,
            },
            wingsGeometry: {
                ...project.wingsGeometry,
                width: project.wingsGeometry && project.wingsGeometry.width! >= 0 ? convertTo(project.wingsGeometry.width!, EConversionSIToImperial.m_to_ft) : undefined,
                offset: project.wingsGeometry && project.wingsGeometry.offset! >= 0 ? convertTo(project.wingsGeometry.offset!, EConversionSIToImperial.m_to_ft) : undefined,
                height: project.wingsGeometry && project.wingsGeometry.height! >= 0 ? convertTo(project.wingsGeometry.height!, EConversionSIToImperial.m_to_ft) : undefined,
            },
            stillingBasin: project.stillingBasin
                ? {
                      ...project.stillingBasin,
                      counterweirElevation: project.stillingBasin.counterweirElevation! >= 0 ? convertTo(project.stillingBasin.counterweirElevation!, EConversionSIToImperial.m_to_ft) : undefined,
                      poolLength: project.stillingBasin.poolLength! >= 0 ? convertTo(project.stillingBasin.poolLength!, EConversionSIToImperial.m_to_ft) : undefined,
                      width: project.stillingBasin.width! >= 0 ? convertTo(project.stillingBasin.width!, EConversionSIToImperial.m_to_ft) : undefined,
                      stillingBasinElevation:
                          project.stillingBasin.stillingBasinElevation || project.stillingBasin.stillingBasinElevation == 0
                              ? convertTo(project.stillingBasin.stillingBasinElevation!, EConversionSIToImperial.m_to_ft)
                              : undefined,
                      thickness: project.stillingBasin.thickness! >= 0 ? convertTo(project.stillingBasin.thickness!, EConversionSIToImperial.m_to_ft) : undefined,
                  }
                : undefined,
            soilData: {
                ...project.soilData,
                rockFillUnitWeight: project.soilData && project.soilData.rockFillUnitWeight! >= 0 ? convertTo(project.soilData.rockFillUnitWeight!, EConversionSIToImperial.kNm3_to_lbfft3) : undefined,
                granularMaterialDownstream:
                    project.soilData && project.soilData.granularMaterialDownstream! >= 0 ? convertTo(project.soilData.granularMaterialDownstream!, EConversionSIToImperial.mm_to_in) : undefined,
                material: {
                    ...project.soilData!.material!,
                    physicalData: project.soilData!.material!.physicalData?.map(pd => ({
                        ...pd,
                        soilUnitWeight: convertTo(pd.soilUnitWeight ?? 0, EConversionSIToImperial.kNm3_to_lbfft3),
                    })),
                },
            },
        };
    }
    return {
        ...state.macra2.project,
        data: roundNumbers(project),
    };
};

export const selectProjectWithoutConversion = (state: RootState): IInitialState<IProjectMacra2> => state.macra2.project!;

export const selectStillingBasinAndSoilDataByProject = (state: RootState) => {
    let projectInfo = state.projectInfo.data;
    let project = state.macra2.project.data;
    let isImperial = projectInfo?.unitOfMeasure == UnitOfMeasure.Imperial;
    let stillingBasin = project?.stillingBasin;
    let soilData = project?.soilData;

    if (isImperial && !!project?.geometry) {
        stillingBasin = {
            ...stillingBasin!,
            counterweirElevation: stillingBasin!.counterweirElevation! >= 0 ? convertTo(stillingBasin!.counterweirElevation!, EConversionSIToImperial.m_to_ft) : undefined,
            poolLength: stillingBasin!.poolLength! >= 0 ? convertTo(stillingBasin!.poolLength!, EConversionSIToImperial.m_to_ft) : undefined,
            width: stillingBasin!.width! >= 0 ? convertTo(stillingBasin!.width!, EConversionSIToImperial.m_to_ft) : undefined,
            stillingBasinElevation:
                stillingBasin!.stillingBasinElevation || stillingBasin!.stillingBasinElevation == 0 ? convertTo(stillingBasin!.stillingBasinElevation!, EConversionSIToImperial.m_to_ft) : undefined,
            material: {
                ...stillingBasin!.material,
                physicalData: stillingBasin!.material!.physicalData?.map(pd => {
                    let thickness = pd.thickness ?? 0;
                    if (thickness === thicknessException) {
                        thickness = Math.ceil(convertTo(thickness, EConversionSIToImperial.m_to_in));
                    } else if (stillingBasin!.material.category == MaterialCategory.Gabion && thickness == thicknessExceptionGabion) {
                        thickness = thicknessImperialValueGabion;
                    } else {
                        thickness = Math.floor(convertTo(thickness, EConversionSIToImperial.m_to_in));
                    }
                    let rockD50 = pd.rockD50 ?? 0;
                    if (stillingBasin!.material.category == MaterialCategory.Gabion && rockD50 == rockD50ExceptionGabion) {
                        rockD50 = rockD50ImperialValueGabion;
                    } else {
                        rockD50 = Math.ceil(convertTo(rockD50 ?? 0, EConversionSIToImperial.m_to_in) * 10) / 10;
                    }
                    return {
                        ...pd,
                        thickness: thickness,
                        rockD50: rockD50,
                        allowShearStress: convertTo(pd.allowShearStress ?? 0, EConversionSIToImperial.Nm2_to_lbfft2),
                        vegetatedAllowShearStress: convertTo(pd.vegetatedAllowShearStress ?? 0, EConversionSIToImperial.Nm2_to_lbfft2),
                    };
                }),
            },
            thickness: stillingBasin!.thickness! >= 0 ? convertTo(stillingBasin!.thickness!, EConversionSIToImperial.m_to_ft) : undefined,
        };

        soilData = {
            ...soilData,
            rockFillUnitWeight: soilData && soilData.rockFillUnitWeight! >= 0 ? convertTo(soilData.rockFillUnitWeight!, EConversionSIToImperial.kNm3_to_lbfft3) : undefined,
            granularMaterialDownstream: soilData && soilData.granularMaterialDownstream! >= 0 ? convertTo(soilData.granularMaterialDownstream!, EConversionSIToImperial.mm_to_in) : undefined,
            material: {
                ...soilData!.material!,
                physicalData: soilData!.material!.physicalData?.map(pd => {
                    let thickness = pd.thickness ?? 0;
                    if (thickness === thicknessException) {
                        thickness = Math.ceil(convertTo(thickness, EConversionSIToImperial.m_to_in));
                    } else if (soilData!.material!.category == MaterialCategory.Gabion && thickness == thicknessExceptionGabion) {
                        thickness = thicknessImperialValueGabion;
                    } else {
                        thickness = Math.floor(convertTo(thickness, EConversionSIToImperial.m_to_in));
                    }
                    let rockD50 = pd.rockD50 ?? 0;
                    if (soilData!.material!.category == MaterialCategory.Gabion && rockD50 == rockD50ExceptionGabion) {
                        rockD50 = rockD50ImperialValueGabion;
                    } else {
                        rockD50 = Math.ceil(convertTo(rockD50 ?? 0, EConversionSIToImperial.m_to_in) * 10) / 10;
                    }
                    return {
                        ...pd,
                        soilUnitWeight: convertTo(pd.soilUnitWeight ?? 0, EConversionSIToImperial.kNm3_to_lbfft3),
                        thickness: thickness,
                        rockD50: rockD50,
                        allowShearStress: convertTo(pd.allowShearStress ?? 0, EConversionSIToImperial.Nm2_to_lbfft2),
                        vegetatedAllowShearStress: convertTo(pd.vegetatedAllowShearStress ?? 0, EConversionSIToImperial.Nm2_to_lbfft2),
                    };
                }),
            },
        };
    }

    return { stillingBasin: roundNumbers(stillingBasin), soilData: roundNumbers(soilData) };
};

export const selectResults = (state: RootState): IInitialState<ISteppedGabionResults | ISlopedGabionResults | IVerticalDropsResults> => {
    let isImperial = state.projectInfo.data?.unitOfMeasure == UnitOfMeasure.Imperial;
    let resultsData = state.macra2.results.data;

    if (isImperial && resultsData) {
        resultsData = {
            ...resultsData,
            hydraulicResult: {
                ...(<IVerticalDropsResults>resultsData).hydraulicResult,
                averageVelocityInChannel: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.averageVelocityInChannel, EConversionSIToImperial.ms_to_fts),
                backwaterDepth: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.backwaterDepth, EConversionSIToImperial.m_to_ft),
                waterCushionElevationAtWeirToe: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.waterCushionElevationAtWeirToe, EConversionSIToImperial.m_to_ft),
                waterDepthDownstreamTheStructure: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.waterDepthDownstreamTheStructure, EConversionSIToImperial.m_to_ft),

                waterDepthOfSupercriticalFlow: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.waterDepthOfSupercriticalFlow, EConversionSIToImperial.m_to_ft),
                waterDepthOnCrest: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.waterDepthOnCrest, EConversionSIToImperial.m_to_ft),
                weirCrestElevation: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.weirCrestElevation, EConversionSIToImperial.m_to_ft),
                scourDepth: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.scourDepth, EConversionSIToImperial.m_to_ft),
                scourLocation: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.scourLocation, EConversionSIToImperial.m_to_ft),
                tailwaterDepthDueToCounterweir: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.tailwaterDepthDueToCounterweir, EConversionSIToImperial.m_to_ft),
                locationOfHydraulicJumpStart: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.locationOfHydraulicJumpStart, EConversionSIToImperial.m_to_ft),
                jumpLengthUsace1990: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.jumpLengthUsace1990, EConversionSIToImperial.m_to_ft),
                minimumBasinLengthUsace1990: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.minimumBasinLengthUsace1990, EConversionSIToImperial.m_to_ft),
                minimumCounterweirElevation: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.minimumCounterweirElevation, EConversionSIToImperial.m_to_ft),
                minimumCounterweirElevationCheck: (<IVerticalDropsResults>resultsData).hydraulicResult?.minimumCounterweirElevationCheck,
                isMainWeirSubmerged: (<IVerticalDropsResults>resultsData).hydraulicResult?.isMainWeirSubmerged,
                isCounterweirSubmerged: (<IVerticalDropsResults>resultsData).hydraulicResult?.isCounterweirSubmerged,
                shearStressInTheBasin: convertTo((<IVerticalDropsResults>resultsData).hydraulicResult?.shearStressInTheBasin, EConversionSIToImperial.Nm2_to_lbfft2),
            },
            staticResult: {
                soilThrustOutput: {
                    ...(<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput,
                    totalHeightOfTheStructure: convertTo((<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.totalHeightOfTheStructure, EConversionSIToImperial.m_to_ft),

                    soilThrustOfTheUpstreamBackfill: convertTo((<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.soilThrustOfTheUpstreamBackfill, EConversionSIToImperial.kN_to_lbf),

                    horizontalComponentOfUpstreamThrust: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.horizontalComponentOfUpstreamThrust,
                        EConversionSIToImperial.kN_to_lbf,
                    ),

                    leverArmOfPamh: convertTo((<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.leverArmOfPamh, EConversionSIToImperial.m_to_ft),
                    momentOfHorizontalUpstreamThrust: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.momentOfHorizontalUpstreamThrust,
                        EConversionSIToImperial.kN_m_to_lbf_ft,
                    ),

                    verticalComponentOfUpstreamThrust: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.verticalComponentOfUpstreamThrust,
                        EConversionSIToImperial.kN_to_lbf,
                    ),

                    leverArmOfPamv: convertTo((<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.leverArmOfPamv, EConversionSIToImperial.m_to_ft),
                    momentOfVerticalUpstreamThrust: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.momentOfVerticalUpstreamThrust,
                        EConversionSIToImperial.kN_m_to_lbf_ft,
                    ),

                    downstreamSoilActiveThrust: convertTo((<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.downstreamSoilActiveThrust, EConversionSIToImperial.kN_to_lbf),

                    leverArmOfPav: convertTo((<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.leverArmOfPav, EConversionSIToImperial.m_to_ft),
                    momentOfDownstreamThrust: convertTo((<IVerticalDropsResults>resultsData).staticResult?.soilThrustOutput.momentOfDownstreamThrust, EConversionSIToImperial.kN_m_to_lbf_ft),
                },
                hydrostaticPressureOutput: {
                    upstreamHydrostaticPressure: convertTo((<IVerticalDropsResults>resultsData).staticResult?.hydrostaticPressureOutput.upstreamHydrostaticPressure, EConversionSIToImperial.kN_to_lbf),

                    leverArmOfUpstreamHydrostaticPressure: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.hydrostaticPressureOutput.leverArmOfUpstreamHydrostaticPressure,
                        EConversionSIToImperial.m_to_ft,
                    ),

                    momentOfUpstreamHydrostaticPressure: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.hydrostaticPressureOutput.momentOfUpstreamHydrostaticPressure,
                        EConversionSIToImperial.kN_m_to_lbf_ft,
                    ),

                    downstreamHydrostaticPressure: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.hydrostaticPressureOutput.downstreamHydrostaticPressure,
                        EConversionSIToImperial.kN_to_lbf,
                    ),

                    leverArmOfDownstreamHydrostaticPressure: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.hydrostaticPressureOutput.leverArmOfDownstreamHydrostaticPressure,
                        EConversionSIToImperial.m_to_ft,
                    ),

                    momentOfDownstreamHydrostaticPressure: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.hydrostaticPressureOutput.momentOfDownstreamHydrostaticPressure,
                        EConversionSIToImperial.kN_m_to_lbf_ft,
                    ),
                },
                upliftPressureOutput: {
                    filtrationLength: convertTo((<IVerticalDropsResults>resultsData).staticResult?.upliftPressureOutput.filtrationLength, EConversionSIToImperial.m_to_ft),
                    upstreamUpliftPressure: convertTo((<IVerticalDropsResults>resultsData).staticResult?.upliftPressureOutput.upstreamUpliftPressure, EConversionSIToImperial.kNm_to_lbfft),

                    downstreamUpliftPressure: convertTo((<IVerticalDropsResults>resultsData).staticResult?.upliftPressureOutput.downstreamUpliftPressure, EConversionSIToImperial.kNm_to_lbfft),

                    hydraulicUplift: convertTo((<IVerticalDropsResults>resultsData).staticResult?.upliftPressureOutput.hydraulicUplift, EConversionSIToImperial.kN_to_lbf),
                    leverArmOfHydraulicUplift: convertTo((<IVerticalDropsResults>resultsData).staticResult?.upliftPressureOutput.leverArmOfHydraulicUplift, EConversionSIToImperial.m_to_ft),

                    momentOfTheHydraulicUplift: convertTo((<IVerticalDropsResults>resultsData).staticResult?.upliftPressureOutput.momentOfTheHydraulicUplift, EConversionSIToImperial.kN_m_to_lbf_ft),
                },
                resultingForcesAndMomentsOutput: {
                    normalForceOnTheFoundation: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.resultingForcesAndMomentsOutput.normalForceOnTheFoundation,
                        EConversionSIToImperial.kN_to_lbf,
                    ),

                    shearStressOnTheFoundation: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.resultingForcesAndMomentsOutput.shearStressOnTheFoundation,
                        EConversionSIToImperial.kN_to_lbf,
                    ),

                    sumOfStabilizingMoments: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.resultingForcesAndMomentsOutput.sumOfStabilizingMoments,
                        EConversionSIToImperial.kN_m_to_lbf_ft,
                    ),

                    sumOfDestibilizingMoments: convertTo(
                        (<IVerticalDropsResults>resultsData).staticResult?.resultingForcesAndMomentsOutput.sumOfDestibilizingMoments,
                        EConversionSIToImperial.kN_m_to_lbf_ft,
                    ),
                },
                stabilityChecksOutput: (<IVerticalDropsResults>resultsData).staticResult?.stabilityChecksOutput,
                weightsOutput: {
                    weirUnitWeight: convertTo((<IVerticalDropsResults>resultsData).staticResult?.weightsOutput.weirUnitWeight, EConversionSIToImperial.kN_to_lbf),
                    leverArmOfTheWeirWeight: convertTo((<IVerticalDropsResults>resultsData).staticResult?.weightsOutput.leverArmOfTheWeirWeight, EConversionSIToImperial.m_to_ft),

                    momentOfTheWeirWeight: convertTo((<IVerticalDropsResults>resultsData).staticResult?.weightsOutput.momentOfTheWeirWeight, EConversionSIToImperial.kN_m_to_lbf_ft),

                    soilUnitWeight: convertTo((<IVerticalDropsResults>resultsData).staticResult?.weightsOutput.soilUnitWeight, EConversionSIToImperial.kN_to_lbf),
                    leverArmOfTheSoilWeight: convertTo((<IVerticalDropsResults>resultsData).staticResult?.weightsOutput.leverArmOfTheSoilWeight, EConversionSIToImperial.m_to_ft),

                    momentOfTheSoilWeight: convertTo((<IVerticalDropsResults>resultsData).staticResult?.weightsOutput.momentOfTheSoilWeight, EConversionSIToImperial.kN_m_to_lbf_ft),

                    waterUnitWeight: convertTo((<IVerticalDropsResults>resultsData).staticResult?.weightsOutput.waterUnitWeight, EConversionSIToImperial.kN_to_lbf),
                    leverArmOfTheWaterWeight: convertTo((<IVerticalDropsResults>resultsData).staticResult?.weightsOutput.leverArmOfTheWaterWeight, EConversionSIToImperial.m_to_ft),

                    momentOfTheWaterWeight: convertTo((<IVerticalDropsResults>resultsData).staticResult?.weightsOutput.momentOfTheWaterWeight, EConversionSIToImperial.kN_m_to_lbf_ft),
                },
            },
            hydraulic: {
                ...(<ISlopedGabionResults>resultsData).hydraulic,

                designDischarge: convertTo((<ISlopedGabionResults>resultsData).hydraulic?.designDischarge, EConversionSIToImperial.m3s_to_ft3s),
                wingsWidth: convertTo((<ISlopedGabionResults>resultsData).hydraulic?.wingsWidth, EConversionSIToImperial.m_to_ft),
                crestLenght: convertTo((<ISlopedGabionResults>resultsData).hydraulic?.crestLenght, EConversionSIToImperial.m_to_ft),
                specificDischargeAtCrest: convertTo((<ISlopedGabionResults>resultsData).hydraulic?.specificDischargeAtCrest, EConversionSIToImperial.m3sm_to_ft3sft),
                upstreamSection: convertTo((<ISlopedGabionResults>resultsData).hydraulic?.upstreamSection, EConversionSIToImperial.m_to_ft),
                criticalHeight: convertTo((<ISlopedGabionResults>resultsData).hydraulic?.criticalHeight, EConversionSIToImperial.m_to_ft),
                criticalVelocity: convertTo((<ISlopedGabionResults>resultsData).hydraulic?.criticalVelocity, EConversionSIToImperial.ms_to_fts),
                criticalHeadAtCrest: convertTo((<ISlopedGabionResults>resultsData).hydraulic?.criticalHeadAtCrest, EConversionSIToImperial.m_to_ft),
                z3: convertTo((<ISlopedGabionResults>resultsData).hydraulic?.z3, EConversionSIToImperial.m_to_ft),
                v3: convertTo((<ISlopedGabionResults>resultsData).hydraulic?.v3, EConversionSIToImperial.ms_to_fts),
                plotPoints: (<ISlopedGabionResults>resultsData).hydraulic?.plotPoints.map(point => ({
                    weirProfileX: convertTo(point.weirProfileX, EConversionSIToImperial.m_to_ft),
                    weirProfileY: convertTo(point.weirProfileY, EConversionSIToImperial.m_to_ft),
                    waterProfileY: convertTo(point.waterProfileY, EConversionSIToImperial.m_to_ft),
                    lunghezzaBrigliaX: convertTo(point.lunghezzaBrigliaX, EConversionSIToImperial.m_to_ft),
                    stress: convertTo(point.stress, EConversionSIToImperial.Nm2_to_lbfft2),
                    isSloping: point.isSloping,
                })),
            },
            basinDesign: {
                shearStress: convertTo((<ISlopedGabionResults | ISteppedGabionResults>resultsData).basinDesign?.shearStress, EConversionSIToImperial.Nm2_to_lbfft2),
                downstreamVelocity: convertTo((<ISlopedGabionResults>resultsData).basinDesign?.downstreamVelocity, EConversionSIToImperial.ms_to_fts),
                downstreamWaterDepth: convertTo((<ISlopedGabionResults>resultsData).basinDesign?.downstreamWaterDepth, EConversionSIToImperial.m_to_ft),
                froudeNumber: (<ISlopedGabionResults>resultsData).basinDesign?.froudeNumber,
                conjugateDepth: convertTo((<ISlopedGabionResults>resultsData).basinDesign?.conjugateDepth, EConversionSIToImperial.m_to_ft),
                jumpLength: convertTo((<ISlopedGabionResults>resultsData).basinDesign?.jumpLength, EConversionSIToImperial.m_to_ft),
                minCounterweirHeight: convertTo((<ISlopedGabionResults | ISteppedGabionResults>resultsData).basinDesign?.minCounterweirHeight, EConversionSIToImperial.m_to_ft),
                thicknessOfRevetment: convertTo((<ISlopedGabionResults>resultsData).basinDesign?.thicknessOfRevetment, EConversionSIToImperial.Nm2_to_lbfft2),
                residualVelocityUnderGeotextile: convertTo((<ISlopedGabionResults>resultsData).basinDesign?.residualVelocityUnderGeotextile, EConversionSIToImperial.ms_to_fts),

                minLengthOfTheCrest: convertTo((<ISteppedGabionResults>resultsData).basinDesign?.minLengthOfTheCrest, EConversionSIToImperial.m_to_ft),
                minLengthOfTheStillingPool: convertTo((<ISteppedGabionResults>resultsData).basinDesign?.minLengthOfTheStillingPool, EConversionSIToImperial.m_to_ft),
                waterVelocity: convertTo((<ISteppedGabionResults>resultsData).basinDesign?.waterVelocity, EConversionSIToImperial.ms_to_fts),
                suggestedLining: (<ISteppedGabionResults>resultsData).basinDesign?.suggestedLining,
                dissipation: (<ISteppedGabionResults>resultsData).basinDesign?.dissipation,
            },
            hydraulicDownstream: {
                ...(<ISteppedGabionResults>resultsData).hydraulicDownstream,
                criticalDepth: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.criticalDepth, EConversionSIToImperial.m_to_ft),
                criticalVelocity: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.criticalVelocity, EConversionSIToImperial.ms_to_fts),
                specificHeadAtTheToe: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.specificHeadAtTheToe, EConversionSIToImperial.m_to_ft),
                totalHeadDownstream: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.totalHeadDownstream, EConversionSIToImperial.m_to_ft),
                waterDepth: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.waterDepth, EConversionSIToImperial.m_to_ft),
                conjugateDepth: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.conjugateDepth, EConversionSIToImperial.m_to_ft),
                hydraulicRadius: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.hydraulicRadius, EConversionSIToImperial.m_to_ft),
                hydraulicJumpLength: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.hydraulicJumpLength, EConversionSIToImperial.m_to_ft),
                waterVelocity: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.waterVelocity, EConversionSIToImperial.ms_to_fts),
                z3: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.z3, EConversionSIToImperial.m_to_ft),
                v3: convertTo((<ISteppedGabionResults>resultsData).hydraulicDownstream?.v3, EConversionSIToImperial.ms_to_fts),
            },
            hydraulicUpstream: {
                ...(<ISteppedGabionResults>resultsData).hydraulicUpstream,
                backwaterDepth: convertTo((<ISteppedGabionResults>resultsData).hydraulicUpstream?.backwaterDepth, EConversionSIToImperial.ms_to_fts),
                criticalDepth: convertTo((<ISteppedGabionResults>resultsData).hydraulicUpstream?.criticalDepth, EConversionSIToImperial.ms_to_fts),
                criticalVelocity: convertTo((<ISteppedGabionResults>resultsData).hydraulicUpstream?.criticalVelocity, EConversionSIToImperial.ms_to_fts),
                specificHeadOnTheCrest: convertTo((<ISteppedGabionResults>resultsData).hydraulicUpstream?.specificHeadOnTheCrest, EConversionSIToImperial.ms_to_fts),
                totalHeadOnTheCrest: convertTo((<ISteppedGabionResults>resultsData).hydraulicUpstream?.totalHeadOnTheCrest, EConversionSIToImperial.ms_to_fts),
            },
        };
    }

    return {
        ...state.macra2.results,
        data: roundNumbers(resultsData),
    };
};
